import { Box, Center, Text, VStack } from '@chakra-ui/react';

import { LoadingDiamondAnimation } from '../pwa/LoadingDiamondAnimation';

export const CHECKOUT_STOCK_CHECK_OVERLAY_TEST_ID =
  'checkout-stock-check-overlay';
export const CHECKOUT_STOCK_CHECK_LOTTIE_TEST_ID =
  'checkout-stock-check-lottie';
export const CHECKOUT_STOCK_CHECK_FALLBACK_TEST_ID =
  'checkout-stock-check-fallback';

export const CHECKOUT_STOCK_CHECK_COPY =
  'Pengecekan Stok Sedang Berlangsung, jangan Menutup Halaman ini';

export const CheckoutStockCheckOverlay = () => {
  return (
    <Box
      alignItems="center"
      bg="rgba(0, 0, 0, 0.5)"
      bottom={0}
      data-testid={CHECKOUT_STOCK_CHECK_OVERLAY_TEST_ID}
      display="flex"
      justifyContent="center"
      left={0}
      pointerEvents="all"
      position="fixed"
      right={0}
      top={0}
      zIndex={1400}
    >
      <Center
        bg="white"
        borderRadius="12px"
        boxShadow="lg"
        maxW="320px"
        mx={4}
        px={8}
        py={10}
        w="full"
      >
        <VStack spacing={6}>
          <LoadingDiamondAnimation
            fallbackTestId={CHECKOUT_STOCK_CHECK_FALLBACK_TEST_ID}
            lottieTestId={CHECKOUT_STOCK_CHECK_LOTTIE_TEST_ID}
          />
          <Text
            color="gray.800"
            fontSize="md"
            fontWeight="bold"
            lineHeight="1.4"
            textAlign="center"
          >
            {CHECKOUT_STOCK_CHECK_COPY}
          </Text>
        </VStack>
      </Center>
    </Box>
  );
};
